import { SvsViews } from './model';
import { ValueAndCauseDTO, CommunicationDTO, VatAndPaymentDTO, CounterExpertiseDTO, RemarkDTO, SigningDTO, SvsDTOLine, SvsDTO } from '../../../business/models/dto/svs/svs.dto';
import { TypeCodeTranslation } from '../../../business/models/shared.model';
import { BusinessValidation } from '../../../business/models/policy-business.model';

export const enum DetailsSvsActionTypes {
  CHANGE_VIEW = '@@svs/CHANGE_VIEW',
  CHANGE_VIEW_BASIC = '@@svs/CHANGE_VIEW_BASIC',
  TAB_VALUE_AND_CAUSE_FIELD_CHANGE = '@@svs/TAB_VALUE_AND_CAUSE_FIELD_CHANGE',
  TAB_COMMUNICATION_FIELD_CHANGE = '@@svs/TAB_COMMUNICATION_FIELD_CHANGE',
  TAB_LINES_FIELD_CHANGE = '@@svs/TAB_LINES_FIELD_CHANGE',
  TAB_LINES_ADD_LINE = '@@svs/TAB_LINES_ADD_LINE',
  TAB_LINES_REMOVE_LINE = '@@svs/TAB_LINES_REMOVE_LINE',
  TAB_LINES_SET_EXCESS_APPLICABLE = '@@svs/TAB_LINES_SET_EXCESS_APPLICABLE',
  TAB_LINES_SET_UNDER_CONDITION = '@@svs/TAB_LINES_SET_UNDER_CONDITION',
  TAB_VAT_AND_PAYMENT_FIELD_CHANGE = '@@svs/TAB_VAT_AND_PAYMENT_FIELD_CHANGE',
  TAB_COUNTER_EXPERTISE_FIELD_CHANGE = '@@svs/TAB_COUNTER_EXPERTISE_FIELD_CHANGE',
  TAB_REMARK_FIELD_CHANGE = '@@svs/TAB_REMARK_FIELD_CHANGE',
  TAB_SIGNING_FIELD_CHANGE = '@@svs/TAB_SIGNING_FIELD_CHANGE',
  FETCH_SVS_LIST = '@@svs/FETCH_SVS_LIST',
  FETCH_SVS_LIST_SUCCESS = '@@svs/FETCH_SVS_LIST_SUCCESS',
  FETCH_SVS_LIST_FAIL = '@@svs/FETCH_SVS_LIST_FAIL',
  FETCH_SVS = '@@svs/FETCH_SVS',
  FETCH_SVS_SUCCESS = '@@svs/FETCH_SVS_SUCCESS',
  FETCH_SVS_FAIL = '@@svs/FETCH_SVS_FAIL',
  FETCH_SVS_ADDITIONAL_SUCCESS = '@@svs/FETCH_SVS_ADDITIONAL_SUCCESS',
  FETCH_SVS_VALIDATE = '@@svs/FETCH_SVS_VALIDATE',
  CHANGE_SVS_ITEM = '@@svs/CHANGE_SVS_ITEM',
  SET_SVS_ID = '@@svs/SET_SVS_ID',
  SET_SVS_LINES = '@@svs/SET_SVS_LINES',
  SET_SVS_LOCKED = '@@svs/SET_SVS_LOCKED',
  RESET_STATE = '@@svs/RESET_STATE',
  UPDATE_SIGNING = '@@svs/UPDATE_SIGNING',
  SET_TAB_AS_SAVED = '@@svs/SET_TAB_AS_SAVED',
  VALIDATE_SVS = '@@svs/VALIDATE_SVS',
  SET_VALIDATED = '@@svs/SET_VALIDATED',
  SET_CURRENT_TAB_AS_DIRTY = '@@svs/SET_CURRENT_TAB_AS_DIRTY',
  IMPORT_LINES_FROM_DACCA_SUCCESS = '@@svs/IMPORT_LINES_FROM_DACCA_SUCCESS',
  UPDATE_SVS_IBAN = '@@detailsSvs/UPDATE_SVS_IBAN',
  UPDATE_SVS_BBAN = '@@detailsSvs/UPDATE_SVS_BBAN'
}

export interface SvsAdditonal {
  readonly insuredPersonName: string;
  readonly insuredAddress: string;
  readonly policySubTypeTC: string;
  readonly contractName: string;
}

export interface DetailsSvsState {
  readonly currentView: SvsViews;
  readonly previousView: SvsViews;

  readonly id: number;
  readonly valueAndCause: ValueAndCauseDTO;
  readonly communication: CommunicationDTO;
  readonly vatAndPayment: VatAndPaymentDTO;
  readonly counterExpertise: CounterExpertiseDTO;
  readonly remark: RemarkDTO;
  readonly signing: SigningDTO;

  readonly currentLine: SvsDTOLine;
  readonly lines: SvsDTOLine[];
  readonly lineAmountTotal: number;
  readonly excessApplicableTC: string | undefined;
  readonly underConditionTC: string | undefined;
  readonly SVSApplicationOfTheExemptionTC: TypeCodeTranslation[];
  readonly SVSSubjectToTC: TypeCodeTranslation[];

  readonly svsItems: SvsItem[];
  readonly svsItemsTabs: { [key: string]: TabDetails };

  readonly additionalData: SvsAdditonal;

  readonly tabs: SvsTab[];

  readonly damageCauseRemarkIsValid: boolean;
  readonly damageRowExcessApplicableIsValid: boolean;
  readonly damageRowUnderConditionIsValid: boolean;
  readonly createdByName: string;
  readonly createdByFirstName: string;
  readonly createdByLastName: string;

  readonly createdByCompany: string;
  readonly createdByCompanyDibCode: string;
  readonly locked: boolean;
  readonly validated: boolean;
  readonly approved?: boolean;
  readonly validations: BusinessValidation[];
}

export interface SvsTab {
  readonly isDirty: boolean;
  readonly isSaved: boolean;
}

export interface TabDetails {
  [view: string]: {
    isSaved: boolean;
    isDirty: boolean;
  };
}
export interface SvsItem {
  readonly id: number;
  readonly total: number;
  readonly locked: boolean;
  readonly svsData: SvsDTO;
}
export interface SvsItemsTab {
  [key: string]: TabDetails;
}
